import axios from 'axios'
import { ALTERAR_DETALHAMENTO_AGENCIA } from '../types'
import { URL } from '../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';

export default function alterarExibicaoDetalhamentoAgencia (agencia) {
  if (agencia.detalhamento) {
    return {
      type: ALTERAR_DETALHAMENTO_AGENCIA,
      payload: { agencia }
    };
  }
  const url = `${URL}/usuarios/empresa/${agencia.idEmpresa}/agencia/${agencia.id}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG)
    .then(
      response => dispatch({
        type: ALTERAR_DETALHAMENTO_AGENCIA,
        payload: { response, agencia }
      })
    );
}
